import { Icon, ListItem, SelectInput, styled } from 'canoe';
import React from 'react';

// import Circle11 from '!!react-svg-loader!./assets/circle-1-1.svg';
import Square11 from '!!react-svg-loader!./assets/square-1-1.svg';
import Square169 from '!!react-svg-loader!./assets/square-16-9.svg';
import Square32 from '!!react-svg-loader!./assets/square-3-2.svg';
import Square54 from '!!react-svg-loader!./assets/square-5-4.svg';
import { SVG } from 'canoe/types/SVG';
import { cropRatioValue } from 'craft/components/SelectedToolbar/ImageCrop/types';
import {
  getRatioStringFromValue,
  getRatioValueFromString,
} from 'craft/components/SelectedToolbar/ImageCrop/utils/helpers';
import {
  CropReducerActions,
  CropReducerActionTypes,
} from 'craft/components/SelectedToolbar/ImageCrop/utils/reducer';

const DropdownWrapper = styled.div`
  width: 120px;
`;

type Item = {
  icon: SVG;
  label: string;
  value: string;
};

const RATIO_OPTIONS: Item[] = [
  {
    icon: Square11,
    label: '1:1',
    value: 'square-1-1',
  },
  // De-scope circular crop mask for now
  // {
  //   icon: Circle11,
  //   label: '1:1',
  //   value: 'circle-1-1',
  //   key: 'circle-1-1',
  // },
  {
    icon: Square32,
    label: '3:2',
    value: 'square-3-2',
  },
  {
    icon: Square54,
    label: '5:4',
    value: 'square-5-4',
  },
  {
    icon: Square169,
    label: '16:9',
    value: 'square-16-9',
  },
];

interface CropRatioProps {
  update: React.Dispatch<CropReducerActions>;
  currentValue: cropRatioValue;
}

export const CropRatioDropdown = ({ update, currentValue }: CropRatioProps) => {
  const dropdownValue = getRatioStringFromValue(currentValue);

  const onRatioSelect = (selected: Item) => {
    update({
      type: CropReducerActionTypes.RatioSelect,
      payload: {
        isCropRatioActive: true,
        cropRatio: getRatioValueFromString(selected?.value),
      },
    });
  };

  const currentItem = RATIO_OPTIONS.find(({ value }) => value === dropdownValue);

  return (
    <DropdownWrapper>
      <SelectInput<Item>
        selectedItem={currentItem}
        clearable={false}
        items={RATIO_OPTIONS}
        onSelect={onRatioSelect}
        placeholder="Crop Ratio"
        scale="small"
        // we do not use a portal for the list, as we are already rendering in a portal / popover
        renderItem={({ item, ...itemProps }) => (
          <ListItem prefix={<Icon svg={item?.icon} color="GlitterGrayL30" />} {...itemProps}>
            {item?.label}
          </ListItem>
        )}
        renderValue={({ selectedItem, ...selectedItemProps }) => (
          <ListItem
            prefix={<Icon svg={selectedItem?.icon} color="GlitterGrayL30" />}
            {...selectedItemProps}
          >
            {selectedItem?.label}
          </ListItem>
        )}
      />
    </DropdownWrapper>
  );
};
